import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { FloatButton } from "antd";
import { Footer, Navbar } from "./Components";
import { Home, NoPage, PrivacyPolicy} from "./Pages";


function App() {
  return (
    <div className="App scroll-smooth bg-white">

      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/*" element={<NoPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>

      <FloatButton.BackTop />
    </div>
  );
}

export default App;
